import { HoldingType } from '../definitions/holding';
import { LocalResource, NotaryProductResource } from '@ligo/bv-flow/store';
import {
  commonProductFields,
  sharedBVProductFields
} from '../../shared/commonProductFields';

export const bvOprichten: LocalResource<HoldingType> = {
  url: '',
  locale: 'main',
  fieldsDescriptions: {
    ...sharedBVProductFields,
    ...commonProductFields
  }
};

export function useMainResource() {
  return {
    main: new NotaryProductResource(bvOprichten, 'main', 'holding')
  };
}
